/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { createTheme } from '@mui/material';

type Theme = Parameters<typeof createTheme>[0];

const baseTheme: Theme = {
  palette: {
    primary: {
      main: '#074a8d',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgb(18 43 69)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '15px',
        },
      },
    },
  },
};

export const defaultTheme = createTheme(baseTheme);

export const inkAiTheme = createTheme({
  ...baseTheme,
  components: {
    ...baseTheme.components,
    MuiToolbar: {
      styleOverrides: {
        // smaller toolbar for add-in
        root: ({ theme }) => ({
          [theme.breakpoints.up('xs')]: {
            minHeight: '40px',
          },
        }),
      },
    },
  },
});
